"use client";

import * as React from "react";
import { cn } from "../../lib/utils";

export interface LeaderboardSummaryCardProps {
  rank: string;
  earnings: string;
  message?: string;
  rankLabel?: string;
  earningsLabel?: string;
  anonymousLabel?: string;
  anonymousHelper?: string;
  anonymousChecked?: boolean;
  onAnonymousChange?: (checked: boolean) => void;
  className?: string;
}

export function LeaderboardSummaryCard({
  rank,
  earnings,
  message,
  rankLabel = "Your rank",
  earningsLabel = "Weekly Earnings",
  anonymousLabel = "Want to stay anonymous?",
  anonymousHelper = "Don't worry we won't show your real name to others.",
  anonymousChecked,
  onAnonymousChange,
  className,
}: LeaderboardSummaryCardProps) {
  return (
    <div
      className={cn(
        "space-y-3 rounded-lg border border-black bg-white px-4 py-4 shadow-[0_4px_0_0_#000000]",
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-[#475467]">{rankLabel}</p>
          <p className="text-[28px] font-semibold text-[#ED5AA9]">{rank}</p>
        </div>
        <div className="text-right">
          <p className="text-sm font-medium text-[#475467]">{earningsLabel}</p>
          <p className="text-[28px] font-semibold text-[#ED5AA9]">{earnings}</p>
        </div>
      </div>
      {message && <p className="text-[10px] font-medium text-[#475467]">{message}</p>}
      <div className="h-px w-full bg-[#EAECF0]" />
      <label className="flex items-start gap-2 rounded-lg px-2 py-1.5">
        <input
          type="checkbox"
          className="mt-1 h-4 w-4 rounded border border-[#D0D5DD]"
          checked={anonymousChecked}
          onChange={(event) => onAnonymousChange?.(event.target.checked)}
        />
        <div className="text-left text-sm text-[#475467]">
          <p className="font-medium">{anonymousLabel}</p>
          <p className="text-xs text-[#667085]">{anonymousHelper}</p>
        </div>
      </label>
    </div>
  );
}
